import { render, staticRenderFns } from "./AppAsterika.vue?vue&type=template&id=7ec76d53&scoped=true"
import script from "./AppAsterika.vue?vue&type=script&lang=js"
export * from "./AppAsterika.vue?vue&type=script&lang=js"
import style0 from "./AppAsterika.vue?vue&type=style&index=0&id=7ec76d53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec76d53",
  null
  
)

export default component.exports